export default "__VITE_ASSET__ahv2Gvd8__ 1232w, __VITE_ASSET__czuy_8sA__ 1232w, __VITE_ASSET__NPWuT8ID__ 1232w, __VITE_ASSET__Ed0nHC9___ 1232w";